import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkitemSimpleTimerComponent } from 'shared/components/workitem-simple-timer/workitem-simple-timer.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    WorkitemSimpleTimerComponent
  ],
  exports: [
    WorkitemSimpleTimerComponent
  ]
})
export class WorkitemSimpleTimerModule {
}
